module.exports = __webpack_public_path__ + "static/media/michael.1d91433a.JPG";